import { useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { Button } from '@calendly/ui/components/button'
import { ArrowExpandIcon } from '@calendly/ui/components/icons'

import { emailSelector } from 'selectors/publisher'
import { useI18n } from 'locales'
import _StyledGmailButton from "gmail_confirmation-StyledGmailButton.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/confirmation/gmail_confirmation.js?styleId=StyledGmailButton";


const StyledGmailButton = /*#__PURE__*/styled(Button, null, {
  displayName: "StyledGmailButton",
  styles: _StyledGmailButton
})

export const GmailConfirmation = () => {
  const { i18n } = useI18n()
  const publisherEmail = useSelector(emailSelector)
  const emailAuthor = `%7Bfrom%3A${publisherEmail} from%3Ano-reply@calendly.com from%3Anotifications@calendly.com%7D`
  const gmailLink = `https://mail.google.com/mail/u/0/#search/${emailAuthor}+in%3Aanywhere+newer_than%3A1d`

  const handleGmailLinkClick = () => {
    window.open(gmailLink, '_blank')
  }

  return (
    <div>
      <StyledGmailButton
        id="booking_sniper_link_cta"
        onClick={handleGmailLinkClick}
        decoration="secondary-outline"
        size="small"
        rel="noopener noreferrer"
        aria-label={i18n.t('booking.templates.open_invitation')}
      >
        {i18n.t('booking.templates.open_invitation')}
        <ArrowExpandIcon size="standard" />
      </StyledGmailButton>
    </div>
  )
}
